import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Joi from "joi-browser";
import ThankYou from "./ThankYou";
import useForm from "../../app/hooks/useForm";
import useControls from "../../app/hooks/useControls";
import { useVerifySecQuestionMutation } from "../../app/store/authApiSlice";

const SecurityQuestion = ({
  handleQuestionBack,
  secQuestion,
  forgotType,
  urlData,
}) => {
  const [secMain, setSecMain] = useState(true);
  const [thankYou, setThankYou] = useState(false);
  const [openIndex, setOpenIndex] = useState(0);

  const [verifySecQuestion] = useVerifySecQuestionMutation();

  const schema = {
    //answer: Joi.string().required().label("Security Answer"),
    // confirmAnswer: Joi.string().required().label("Confirm Security Answer"),
    captcha: Joi.string().required().label("Captcha"),
  };

  if (secQuestion !== undefined && secQuestion !== "") {
    secQuestion.map(
      (item, key) =>
      (schema[`answer_${item.id}`] = Joi.string()
        .required()
        .label(`Answer ${key + 1}`))
    );
  }

  const onCaptchaChange = (value) => {
    setStateData({ ...stateData, captcha: value });
  };

  const doSubmit = async () => {
    const secAnswer = [];
    secQuestion.map((item) => {
      const obj = {
        id: item.id,
        hintAnswer1: stateData[`answer_${item.id}`],
        type: forgotType,
      };
      secAnswer.push(obj);
    });
    const { data: result } = await verifySecQuestion(secAnswer);
    if (result === "success") {
      setSecMain(false);
      setThankYou(true);
    } else {
      const ansId = secQuestion[secQuestion.length - 1].id;
      setStateErrors({ ...stateErrors, [`answer_${ansId}`]: "Invalid Details" });
    }
  };

  const {
    stateData,
    setStateData,
    stateErrors,
    setStateErrors,
    handleChange,
    validate,
    handleSubmit,
  } = useForm(schema, doSubmit);

  const { renderInput } = useControls(
    stateData,
    stateErrors,
    handleChange,
    schema
  );

  return (
    <React.Fragment>
      {secMain && (
        <div className="row">
          <div className="col-md-12 mb-3">
            <button
              className="btn btn-link btn-sm login-back"
              onClick={handleQuestionBack}
            >
              <i className="fa fa-arrow-left" aria-hidden="true"></i>
              Back
            </button>
          </div>
          {secQuestion !== "" && secQuestion !== undefined && (
            <div className="col-md-12" style={{ marginBottom: "10px" }}>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginBottom: openIndex >= 0 ? "14px" : 0,
                }}
              >
                {secQuestion.map((item, key) => {
                  const isOpen = openIndex === key;
                  const isAnswered = !!String(stateData[`answer_${item.id}`] || "").trim();
                  return (
                    <button
                      key={item.id}
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? -1 : key)}
                      style={{
                        flex: "1 1 0",
                        minWidth: "140px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "8px",
                        padding: "12px",
                        borderRadius: "8px",
                        border: `1px solid ${isAnswered ? "#6ee7b7" : isOpen ? "#a9c4e6" : "#d8dee8"}`,
                        background: isAnswered ? "#ecfdf5" : isOpen ? "#f7fbff" : "#ffffff",
                        color: isAnswered ? "#047857" : "#172b4d",
                        fontSize: "13px",
                        fontWeight: 600,
                        cursor: "pointer",
                      }}
                    >
                      <span style={{ display: "flex", alignItems: "center", gap: "6px", minWidth: 0, flex: 1 }}>
                        {isAnswered && (
                          <i className="fa fa-check-circle" aria-hidden="true" style={{ color: "#059669", flexShrink: 0 }}></i>
                        )}
                        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          Security Question {key + 1}
                        </span>
                      </span>
                      <i
                        className={`fa ${isOpen ? "fa-chevron-up" : "fa-chevron-down"}`}
                        aria-hidden="true"
                        style={{ color: isAnswered ? "#059669" : "#1a2c52", flexShrink: 0 }}
                      ></i>
                    </button>
                  );
                })}
              </div>
              {openIndex >= 0 && secQuestion[openIndex] && (
                <div>
                  <p style={{ fontWeight: 600, color: "#172b4d", marginBottom: "10px" }}>
                    {secQuestion[openIndex].question1}
                  </p>
                  {renderInput(
                    `answer_${secQuestion[openIndex].id}`,
                    "Answer " + (openIndex + 1),
                    "password"
                  )}
                </div>
              )}
            </div>
          )}
          {/*

          <div className="col-md-12">
            {renderInput("confirmAnswer", "Confirm Answer", "password")}
          </div> */}
          <div className="col-md-12 form-group">
            <ReCAPTCHA
              sitekey="6Le08xsUAAAAAKC6Oglhe-haRVGzA8KTLUZ-jmEK"
              onChange={onCaptchaChange}
            />
          </div>
          <div className="col-md-12">
            <button
              className="btn btn-outline-default w-100"
              onClick={handleSubmit}
              disabled={!!validate()}
            >
              Submit
            </button>
          </div>
        </div>
      )}
      {thankYou && (
        <ThankYou forgotType={forgotType} urlData={urlData}></ThankYou>
      )}
    </React.Fragment>
  );
};

export default SecurityQuestion;
